import { Badge } from '@/components/ui/badge'
import { Banner } from '@/components/ui/banner'
import {
  DECLINE_BADGE_CLASSES,
  DECLINE_CATEGORY_LABELS,
  declineBadge,
} from '../../../../../components/Chat/declineDisplay'
import type { QuoteDeclineDetail } from '../../../../../models/insuranceQuote'

interface QuoteDeclineBannerProps {
  detail: QuoteDeclineDetail
  isError: boolean
}

/** A declined or errored quote's reason, laid out like the price card's decline banner. */
export function QuoteDeclineBanner({ detail, isError }: QuoteDeclineBannerProps) {
  const badge = declineBadge(detail)
  return (
    <Banner variant={isError ? 'error' : 'warning'} small>
      <div className="mb-1 flex items-center justify-between gap-2 border-b border-dashed border-current/30 pb-1">
        <span className="text-[11px] font-bold tracking-wide uppercase">
          {DECLINE_CATEGORY_LABELS[detail.category]}
        </span>
        <Badge variant="outline" className={DECLINE_BADGE_CLASSES[badge]}>
          {badge}
        </Badge>
      </div>
      {detail.staffNote && <div>{detail.staffNote}</div>}
      {detail.carrierReason && (
        <div className="overflow-x-auto break-words whitespace-pre-wrap">{detail.carrierReason}</div>
      )}
      <div className="text-foreground/80 mt-1">{detail.nextStep}</div>
    </Banner>
  )
}
